var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "footer_logo",
    "data-name": "footer logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 341.874,
    height: 267.95,
    viewBox: "0 0 341.874 267.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M32.8,110.912V20.2H84.644v90.707A24.622,24.622,0,0,1,60.035,135.54H57.426A24.632,24.632,0,0,1,32.8,110.912M91.6,5.339H20.627c-4.431,0-8.008,3.328-8.008,7.423A7.739,7.739,0,0,0,20.627,20.2h1.41v90.707a35.427,35.427,0,0,0,35.389,35.4h2.609a35.427,35.427,0,0,0,35.389-35.4V20.2h1.4a7.739,7.739,0,0,0,8.008-7.442c0-4.1-3.577-7.423-8.008-7.423Z",
    transform: "translate(-12.619 -5.339)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.539,
    cy: -0.273,
    r: 1.4,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fd5e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#2b926b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b926b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_245",
    "data-name": "Rectangle 245",
    width: 9.485,
    height: 4.268,
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -1.141,
    cy: -14.08,
    r: 33.062,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_247",
    "data-name": "Rectangle 247",
    width: 9.485,
    height: 4.287,
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: -1.453,
    cy: -12.493,
    r: 32.974,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_249",
    "data-name": "Rectangle 249",
    width: 9.485,
    height: 4.277,
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: -0.844,
    cy: -15.527,
    r: 33.018,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M15.187,16.786V52.3A20.242,20.242,0,0,0,35.394,72.517h2.541A20.236,20.236,0,0,0,58.143,52.3V15.079a13.753,13.753,0,0,1-6.464,1.151C44.572,15.683,35.279,12.2,27.2,12.2c-4.613,0-8.823,1.132-12.017,4.584",
    transform: "translate(-15.187 -12.202)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.713,
    cy: -1.627,
    r: 3.224,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M24.915,17.051A88.589,88.589,0,0,1,29.6,28.924h8.123a61.168,61.168,0,0,1,2.522-6.608c3.2-7,7.039-11.71,11.278-14.28.345-.221.691-.393,1.036-.585a31.151,31.151,0,0,0-8.171,1.918A27.5,27.5,0,0,0,35.234,15.4c-.566.537-1.132,1.132-1.678,1.736l-.038-.086c-.777-.758-1.592-1.515-2.436-2.3a171.028,171.028,0,0,0-15.354-12.5l-.019-.01a106.918,106.918,0,0,1,9.207,14.808",
    transform: "translate(-15.708 -2.243)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: -0.013,
    cy: -0.671,
    r: 6.242,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M16.991,6.746a5.557,5.557,0,0,0,4.651,6.32,5.474,5.474,0,0,0,6.148-4.8,5.586,5.586,0,0,0-4.651-6.339,5.038,5.038,0,0,0-.758-.058,5.513,5.513,0,0,0-5.39,4.872",
    transform: "translate(-16.936 -1.874)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: -1.164,
    cy: -1.672,
    r: 15.594,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M56.507,8.689A101.738,101.738,0,0,0,38.353,23.257c-1.074,1.074-2.158,2.2-3.2,3.318v-.125c-.7-.978-1.41-1.956-2.167-2.954A95.172,95.172,0,0,0,19.335,9.149l-.01-.01a100.065,100.065,0,0,1,4.987,19.574,111.239,111.239,0,0,1,.729,19.478h7.4c3.021-5.323,6.167-10.4,9.485-15.1,9.025-12.8,18.97-23.4,29.424-31.16.9-.662,1.8-1.3,2.695-1.937A108.961,108.961,0,0,0,56.507,8.689",
    transform: "translate(-19.325)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: -0.509,
    cy: -0.223,
    r: 3.648,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M20.353,8.024c0,4.431,3.29,8.018,7.375,8.018S35.1,12.455,35.1,8.024c0-4.4-3.3-7.989-7.375-7.989s-7.375,3.587-7.375,7.989",
    transform: "translate(-20.353 -0.035)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: -2.795,
    cy: -0.87,
    r: 11.542,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M12.851,2.379C23.055,9.9,32.78,20.16,41.6,32.561c2.513,3.548,4.93,7.337,7.279,11.259h9.073a103.339,103.339,0,0,1,.854-15.489A94.971,94.971,0,0,1,63.7,9.361l-.019.01a94.027,94.027,0,0,0-13.34,13.9c-.738.959-1.429,1.918-2.12,2.858l.019.134c-1.026-1.093-2.091-2.167-3.146-3.232a98.724,98.724,0,0,0-17.733-14.1A106.051,106.051,0,0,0,10.223.509c.863.6,1.765,1.228,2.628,1.87",
    transform: "translate(-10.223 -0.509)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 0.78,
    cy: 0.121,
    r: 3.97,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M13.29,8.291A7.5,7.5,0,0,0,20.5,16.05a7.489,7.489,0,0,0,7.212-7.759A7.492,7.492,0,0,0,20.5.542,7.5,7.5,0,0,0,13.29,8.291",
    transform: "translate(-13.29 -0.542)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 0.743,
    cy: -0.104,
    r: 11.889,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_257",
    "data-name": "Rectangle 257",
    width: 341.874,
    height: 267.95,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_407",
    "data-name": "Group 407",
    transform: "translate(121.023 51.205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_406",
    "data-name": "Group 406",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_243",
    "data-name": "Rectangle 243",
    width: 129.281,
    height: 161.72,
    transform: "translate(-39.286 11.963) rotate(-16.937)",
    fill: "url(#radial-gradient)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_409",
    "data-name": "Group 409",
    transform: "translate(176.101 89.086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_408",
    "data-name": "Group 408",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_244",
    "data-name": "Rectangle 244",
    width: 10.317,
    height: 6.846,
    transform: "translate(-1.189 0.362) rotate(-16.937)",
    fill: "url(#radial-gradient-2)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_411",
    "data-name": "Group 411",
    transform: "translate(176.101 77.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_410",
    "data-name": "Group 410",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_246",
    "data-name": "Rectangle 246",
    width: 10.322,
    height: 6.864,
    transform: "translate(-1.195 0.364) rotate(-16.937)",
    fill: "url(#radial-gradient-3)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_413",
    "data-name": "Group 413",
    transform: "translate(176.101 99.588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_412",
    "data-name": "Group 412",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_248",
    "data-name": "Rectangle 248",
    width: 10.32,
    height: 6.855,
    transform: "translate(-1.192 0.363) rotate(-16.937)",
    fill: "url(#radial-gradient-4)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_415",
    "data-name": "Group 415",
    transform: "translate(145.651 117.024)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_414",
    "data-name": "Group 414",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_250",
    "data-name": "Rectangle 250",
    width: 58.664,
    height: 70.213,
    transform: "translate(-16.809 5.118) rotate(-16.937)",
    fill: "url(#radial-gradient-5)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_417",
    "data-name": "Group 417",
    transform: "translate(150.648 21.512)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_416",
    "data-name": "Group 416",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_251",
    "data-name": "Rectangle 251",
    width: 43.03,
    height: 36.261,
    transform: "translate(-7.435 2.263) rotate(-16.937)",
    fill: "url(#radial-gradient-6)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_419",
    "data-name": "Group 419",
    transform: "translate(162.428 17.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_418",
    "data-name": "Group 418",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_252",
    "data-name": "Rectangle 252",
    width: 14.533,
    height: 14.514,
    transform: "translate(-3.607 0.986) rotate(-16.937)",
    fill: "url(#radial-gradient-7)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_421",
    "data-name": "Group 421",
    transform: "translate(185.337 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_420",
    "data-name": "Group 420",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_253",
    "data-name": "Rectangle 253",
    width: 66.389,
    height: 62.044,
    transform: "translate(-13.43 4.089) rotate(-16.937)",
    fill: "url(#radial-gradient-8)"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_423",
    "data-name": "Group 423",
    transform: "translate(195.196 0.336)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_422",
    "data-name": "Group 422",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_254",
    "data-name": "Rectangle 254",
    width: 18.773,
    height: 19.609,
    transform: "translate(-4.461 1.357) rotate(-16.937)",
    fill: "url(#radial-gradient-9)"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_425",
    "data-name": "Group 425",
    transform: "translate(98.044 4.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_424",
    "data-name": "Group 424",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_255",
    "data-name": "Rectangle 255",
    width: 63.775,
    height: 57.011,
    transform: "translate(-12.07 3.675) rotate(-16.937)",
    fill: "url(#radial-gradient-10)"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427",
    transform: "translate(127.458 5.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_426",
    "data-name": "Group 426",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_256",
    "data-name": "Rectangle 256",
    width: 18.316,
    height: 19.037,
    transform: "translate(-4.322 1.315) rotate(-16.937)",
    fill: "url(#radial-gradient-11)"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_429",
    "data-name": "Group 429",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M34.459,64.057v9.974H0V22.453H11.6v41.6Z",
    transform: "translate(-0.002 192.884)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M20.587,23.64a25.872,25.872,0,0,1,8.19,1.112,12.774,12.774,0,0,1,5.246,3.2,11.9,11.9,0,0,1,2.791,5.064,25.3,25.3,0,0,1,.825,6.617V62.712Q35.251,63.23,31,63.939a63.675,63.675,0,0,1-10.262.71,32.941,32.941,0,0,1-6.886-.671,15.123,15.123,0,0,1-5.332-2.2A10.173,10.173,0,0,1,5.108,57.8a13.75,13.75,0,0,1-1.189-6.032,11.371,11.371,0,0,1,1.381-5.8,10.491,10.491,0,0,1,3.673-3.8,16.735,16.735,0,0,1,5.294-2.043,29.52,29.52,0,0,1,6.176-.633,34.82,34.82,0,0,1,3.827.182,17.954,17.954,0,0,1,2.714.48V39.119a6.1,6.1,0,0,0-1.707-4.536q-1.712-1.712-5.956-1.717a37.317,37.317,0,0,0-5.582.412,23.639,23.639,0,0,0-4.766,1.151L7.563,25.5c.643-.192,1.448-.412,2.417-.633s2.024-.422,3.165-.595,2.35-.326,3.616-.451,2.532-.182,3.827-.182m.892,32.445c1.093,0,2.139-.019,3.127-.077a21.816,21.816,0,0,0,2.378-.221V47.377c-.441-.1-1.112-.192-2-.3a23.2,23.2,0,0,0-2.455-.144,21.712,21.712,0,0,0-2.935.182,7.821,7.821,0,0,0-2.426.71,4.112,4.112,0,0,0-1.63,1.41,3.9,3.9,0,0,0-.6,2.235,3.812,3.812,0,0,0,1.755,3.616,9.727,9.727,0,0,0,4.8,1",
    transform: "translate(33.666 203.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M44.683,59.989A24.7,24.7,0,0,1,43.3,68.477a18.082,18.082,0,0,1-3.98,6.474,17.615,17.615,0,0,1-6.406,4.124,23.97,23.97,0,0,1-8.622,1.458c-1.343,0-2.743-.067-4.21-.192s-2.9-.278-4.316-.48-2.772-.432-4.057-.71-2.436-.556-3.424-.854v-54.7l11.087-1.784v19.5a20.006,20.006,0,0,1,3.865-1.256,19.375,19.375,0,0,1,4.325-.451,17.65,17.65,0,0,1,7.366,1.448,14.513,14.513,0,0,1,5.361,4.134,18.771,18.771,0,0,1,3.27,6.435,29.186,29.186,0,0,1,1.122,8.373m-11.317-.3q0-10.717-7.883-10.713a13.143,13.143,0,0,0-3.4.441,9.767,9.767,0,0,0-2.714,1.112V70.7c.547.105,1.237.192,2.091.269s1.755.105,2.752.105a7.966,7.966,0,0,0,6.848-3.126,13.592,13.592,0,0,0,2.3-8.257",
    transform: "translate(71.19 187.352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M26.081,55.864A11.146,11.146,0,0,0,30.4,55.27a2.311,2.311,0,0,0,1.266-2.311,2.811,2.811,0,0,0-1.64-2.34,30.815,30.815,0,0,0-4.977-2.273,48.891,48.891,0,0,1-4.738-2.014A13.879,13.879,0,0,1,16.7,43.847a10.229,10.229,0,0,1-2.3-3.462,12.817,12.817,0,0,1-.825-4.843,10.464,10.464,0,0,1,4.1-8.7q4.086-3.208,11.24-3.2a36.074,36.074,0,0,1,6.848.633,31.84,31.84,0,0,1,5.208,1.381l-1.928,8.631a42.571,42.571,0,0,0-4.21-1.2,23.01,23.01,0,0,0-5.1-.518c-3.462,0-5.208.969-5.208,2.906a3.093,3.093,0,0,0,.221,1.189,2.663,2.663,0,0,0,.892,1.007,13.139,13.139,0,0,0,1.832,1.045q1.151.561,2.935,1.237a44.331,44.331,0,0,1,6.023,2.666,14.315,14.315,0,0,1,3.769,2.829,8.7,8.7,0,0,1,1.928,3.385,14.874,14.874,0,0,1,.556,4.3A9.923,9.923,0,0,1,38.318,61.9Q33.974,64.86,26,64.86a35.521,35.521,0,0,1-8.67-.882,34.011,34.011,0,0,1-4.8-1.5L14.4,53.476a36.1,36.1,0,0,0,5.8,1.755,28.2,28.2,0,0,0,5.879.633",
    transform: "translate(107.717 203.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M49.077,22.453V53.411h5.5v9.082h-5.5V74.021H38.211V62.493H15.961V54.38c1.084-2.187,2.455-4.651,4.086-7.4s3.462-5.582,5.476-8.488,4.124-5.735,6.359-8.516a94.785,94.785,0,0,1,6.694-7.519ZM38.211,35.995q-2.906,3.8-6.186,8.257a57.98,57.98,0,0,0-5.5,9.159H38.211Z",
    transform: "translate(137.113 192.884)",
    fill: "#4bb599"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M20.641,74.022V22.454H55.176V32.2H32.245V42.987H52.635V52.74H32.245V74.022Z",
    transform: "translate(177.314 192.888)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M48.26,34.309c-1-.249-2.158-.508-3.491-.786a21.976,21.976,0,0,0-4.316-.412,19.726,19.726,0,0,0-2.494.192,14.093,14.093,0,0,0-2.206.412V63.627H24.667V26.569a68.289,68.289,0,0,1,7.03-1.976,40.48,40.48,0,0,1,9.053-.93c.585,0,1.314.038,2.148.115s1.688.173,2.532.3,1.688.269,2.532.441a13.39,13.39,0,0,1,2.158.633Z",
    transform: "translate(211.903 203.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M27.476,44.547a24.008,24.008,0,0,1,1.592-9.111,19.636,19.636,0,0,1,4.21-6.512,17.428,17.428,0,0,1,5.994-3.942,18.754,18.754,0,0,1,6.953-1.343q8.329,0,13.168,5.093t4.843,15c0,.643-.029,1.352-.077,2.119s-.1,1.448-.144,2.052H38.86a7.361,7.361,0,0,0,3.2,5.428,12.814,12.814,0,0,0,7.586,2,31.823,31.823,0,0,0,5.994-.556,22.359,22.359,0,0,0,4.8-1.371l1.477,9.006a15.418,15.418,0,0,1-2.378.892,31.3,31.3,0,0,1-3.309.777c-1.218.221-2.513.412-3.913.566a40.386,40.386,0,0,1-4.172.221,24.8,24.8,0,0,1-9.188-1.563A17.886,17.886,0,0,1,32.5,59.029a16.9,16.9,0,0,1-3.8-6.445,25.253,25.253,0,0,1-1.228-8.037m26.048-4.239a11.593,11.593,0,0,0-.489-2.753,6.7,6.7,0,0,0-3.424-4.1,7.076,7.076,0,0,0-3.232-.671,7.425,7.425,0,0,0-3.2.633A6.691,6.691,0,0,0,40.941,35.1a7.306,7.306,0,0,0-1.371,2.417,15.277,15.277,0,0,0-.71,2.791Z",
    transform: "translate(236.033 203.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M31.814,44.547a24.008,24.008,0,0,1,1.592-9.111,19.636,19.636,0,0,1,4.21-6.512,17.428,17.428,0,0,1,5.994-3.942,18.754,18.754,0,0,1,6.953-1.343q8.329,0,13.168,5.093t4.843,15c0,.643-.029,1.352-.077,2.119s-.1,1.448-.144,2.052H43.2a7.361,7.361,0,0,0,3.2,5.428,12.814,12.814,0,0,0,7.586,2,31.822,31.822,0,0,0,5.994-.556,22.358,22.358,0,0,0,4.8-1.371l1.477,9.006a15.418,15.418,0,0,1-2.378.892,31.3,31.3,0,0,1-3.309.777c-1.218.221-2.513.412-3.913.566a40.385,40.385,0,0,1-4.172.221A24.8,24.8,0,0,1,43.3,63.306a17.886,17.886,0,0,1-6.464-4.277,16.9,16.9,0,0,1-3.8-6.445,25.253,25.253,0,0,1-1.228-8.037m26.048-4.239a11.591,11.591,0,0,0-.489-2.753,6.7,6.7,0,0,0-3.424-4.1,7.076,7.076,0,0,0-3.232-.671,7.425,7.425,0,0,0-3.2.633A6.692,6.692,0,0,0,45.279,35.1a7.305,7.305,0,0,0-1.371,2.417,15.276,15.276,0,0,0-.71,2.791Z",
    transform: "translate(273.299 203.081)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterlogo);
export default __webpack_public_path__ + "static/media/footer logo.fbfe6d6bbcba0c1114b85cee60684a34.svg";
export { ForwardRef as ReactComponent };